module.exports=function(scope){ return `{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The FaceTec 3D FaceMap evaluated and Liveness was proven."
    },
    "data": {
        "ageCheckResult": 0
    }
}

<!-- NOTE: Server REST API provides additional properties for this end point. -->
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/success/age-check.json.tpl